/* @flow */
import idx from 'idx';
import * as React from 'react';
import { graphql } from 'react-apollo';
import update from 'immutability-helper';
import PreferredVoiceCallDevice from './PreferredVoiceCallDevice';
import GET_DEVICES_QUERY from 'settings/queries/devicesQuery.gql';
import UPDATE_DEVICES_MUTATION from '../queries/UpdatePreferredVoiceCallsDeviceMutation.gql';

import type { Devices, Devices_devices } from 'settings/queries/__generated__/Devices';
import type { updatePreferredVoiceCallsDeviceVariables } from '../queries/__generated__/updatePreferredVoiceCallsDevice';

type Props = {
  mutate: (input: { variables: updatePreferredVoiceCallsDeviceVariables }) => Promise<*>,
  data: ReactApolloData<Devices>,
};

function buildOptimisticMutationResponse(device: Devices_devices) {
  return {
    updatePreferredVoiceCallsDevice: {
      __typename: 'updatePreferredVoiceCallsDevicePayload',
      device: {
        ...device,
        is_preferred_voice_calls_device: true,
      },
    },
  };
}

// $FlowFixMe
export function updateStoreOnResponse(store, { data }) {
  const oldData = store.readQuery({ query: GET_DEVICES_QUERY });
  const preferred = data.updatePreferredVoiceCallsDevice.device.id;

  // update all but the preferred device is_preferred_voice_calls_device to false
  const newData = update(oldData, {
    devices: {
      $apply: items => {
        return items.map(item => {
          return update(item, {
            is_preferred_voice_calls_device: {
              $set: item.id === preferred,
            },
          });
        });
      },
    },
  });

  store.writeQuery({ query: GET_DEVICES_QUERY, data: newData });
}

class PreferredVoiceCallDeviceContainer extends React.Component<Props> {
  setPreferredVoiceCallsDevice = (device: Devices_devices) => {
    this.props.mutate({
      variables: { value: device.id },
      optimisticResponse: buildOptimisticMutationResponse(device),
      update: updateStoreOnResponse,
    });
  };

  getDevices = () => {
    return idx(this.props.data, _ => _.devices) || [];
  };

  getVoiceEnabledDevices = (): any[] => {
    return this.getDevices().filter(device => device.type === 'sms' || device.type === 'landline');
  };

  render() {
    return (
      <PreferredVoiceCallDevice
        devices={this.getVoiceEnabledDevices()}
        setPreferredVoiceCallsDevice={this.setPreferredVoiceCallsDevice}
      />
    );
  }
}

const withPhoneCallPreferenceMutation = graphql(UPDATE_DEVICES_MUTATION);
const withDevices = graphql(GET_DEVICES_QUERY);

export { PreferredVoiceCallDeviceContainer };
export default withDevices(withPhoneCallPreferenceMutation(PreferredVoiceCallDeviceContainer));
